import { render } from "./PDF.vue?vue&type=template&id=2625fa18&scoped=true"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"

import "./PDF.vue?vue&type=style&index=0&id=2625fa18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2625fa18"]])

export default __exports__